(function () {
  'use strict';
  if (window.__OP_AU_COMPARE_READY__) return;
  window.__OP_AU_COMPARE_READY__ = true;

  var MAX_MODELS = 4;
  var active = null;
  var state = null;
  var lastFocus = null;
  var previousOverflow = '';

  function formatPrice(price, currency) {
    if (!price || !Number.isFinite(Number(price.amount))) return '';
    var code = currency || 'AUD';
    try {
      var formatted = new Intl.NumberFormat('en-AU', {style:'currency',currency:code,currencyDisplay:'code'}).format(price.amount / 100);
      return (price.varies ? 'From ' : '') + formatted;
    } catch (error) { return ''; }
  }
  function savePrice(model, amount, varies) {
    if (!state || amount == null || !Number.isFinite(Number(amount))) return;
    state.prices[model.id] = {amount:Number(amount),varies:!!varies};
  }
  function showPrices() {
    if (!state || !active) return;
    active.querySelectorAll('[data-op-au-compare-price]').forEach(function (element) {
      var value = formatPrice(state.prices[element.dataset.opAuComparePrice], state.catalog.currency);
      element.textContent = value || (state.loading[element.dataset.opAuComparePrice] ? 'Loading price…' : 'Price unavailable');
    });
  }
  function loadPrice(model) {
    if (!state || !active || state.prices[model.id] || state.loading[model.id]) return;
    state.loading[model.id] = true;
    var requestState = state;
    var candidates = [model.handle];
    // When a bundle's product handle is unavailable, try other mapped packages.
    Object.keys(requestState.catalog.sheet.aliases || {}).forEach(function (alias) {
      if (requestState.catalog.sheet.aliases[alias] === model.id && candidates.indexOf(alias) === -1) candidates.push(alias);
    });
    var endpointRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function attempt(index) {
      if (index >= candidates.length) {
        delete requestState.loading[model.id];
        if (state === requestState) showPrices();
        return;
      }
      var path = endpointRoot.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(candidates[index]) + '.js';
      fetch(path, {credentials:'same-origin'}).then(function (response) {
        if (!response.ok) throw new Error('Product not found');
        return response.json();
      }).then(function (result) {
        if (state !== requestState) return;
        var amount = result.price;
        if (amount == null && Array.isArray(result.variants) && result.variants.length) {
          amount = Math.min.apply(null,result.variants.map(function (variant) { return Number(variant.price); }));
        }
        if (amount == null || !Number.isFinite(Number(amount))) throw new Error('Price not found');
        savePrice(model,amount,result.price_varies);
        model.url = '/products/' + candidates[index];
        if (state && state.catalog && state.catalog.byId[model.id]) {
          state.catalog.byId[model.id].url = model.url;
        }
        if (active) active.querySelectorAll('[data-op-au-compare-model-link="' + model.id + '"]').forEach(function (link) {link.href=model.url;});
        delete requestState.loading[model.id];
        showPrices();
      }).catch(function () { attempt(index+1); });
    }
    attempt(0);
  }
  function priceElement(model) {
    var price = make('span','op-au-compare-price');
    price.dataset.opAuComparePrice = model.id;
    price.textContent = state && formatPrice(state.prices[model.id], state.catalog.currency) || 'Loading price…';
    return price;
  }
  function featureLabel(row) {
    var wrapper = make('div','op-au-compare-feature-label');
    wrapper.appendChild(make('span','',row.label));
    var dictionary = window.OBDPRICE_AU_COMPARE_HELP;
    var help = dictionary && state && dictionary[state.catalog.group] && dictionary[state.catalog.group][row.id];
    if (help) {
      var trigger = make('button','op-au-compare-help-trigger','i');
      trigger.type='button';
      trigger.dataset.opAuCompareHelp='';
      trigger.setAttribute('aria-label','Explain '+row.label);
      trigger.setAttribute('aria-expanded','false');
      var explanation = make('span','op-au-compare-help-text',help);
      explanation.hidden=true;
      wrapper.appendChild(trigger);
      wrapper.appendChild(explanation);
    }
    return wrapper;
  }

  function make(tag, className, value) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (value !== undefined && value !== null) element.textContent = String(value);
    return element;
  }
  function clean(value) { return String(value == null ? '' : value).trim(); }
  function normalized(value) {
    var v = clean(value).toLowerCase().replace(/\s+/g, '');
    if (/^(?:√|✔|✓|✅|yes|true)$/.test(v)) return '__yes__';
    if (/^(?:x|✘|✗|×|❌|no|false|notsupported|unsupported)$/.test(v)) return '__no__';
    return v;
  }
  function unsupported(value) {
    var v = normalized(value);
    return !v || v === '__no__' || v === '/' || v === '—' || v === '-';
  }
  function valueStyle(value) {
    if (normalized(value) === '__yes__') return 'yes';
    if (normalized(value) === '__no__') return 'no';
    return '';
  }
  function presentation(value) {
    var v = clean(value);
    var n = normalized(v);
    if (n === '__yes__') return '✓';
    if (n === '__no__') return '–';
    return v || '–';
  }
  function getRoot(button) { return button.closest('.cs_related_products_section'); }
  function getContext(root) {
    var script = root && root.querySelector('[data-op-au-compare-context]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (error) { return null; }
  }
  function resolveHandle(sheet, handle) {
    if (!sheet || !handle) return '';
    if (Object.prototype.hasOwnProperty.call(sheet.models, handle)) return handle;
    return (sheet.aliases && sheet.aliases[handle]) || handle;
  }
  function hasModel(sheet, handle) {
    return !!(sheet && sheet.models[resolveHandle(sheet, handle)]);
  }
  function getCatalog(context) {
    var data = window.OBDPRICE_AU_COMPARE_DATA;
    if (!data || !context || !Array.isArray(context.models)) return null;

    var seenHandles = Object.create(null);
    var related = [];
    context.models.forEach(function (item) {
      if (!item || !item.handle || seenHandles[item.handle]) return;
      seenHandles[item.handle] = true;
      related.push(item);
    });
    if (context.current && !seenHandles[context.current]) {
      related.unshift({ handle: context.current, url: context.url || location.pathname,
        price: context.currentPrice, priceVaries: context.currentPriceVaries });
    }

    var group;
    if (hasModel(data.cv, context.current)) group = 'cv';
    else if (hasModel(data.immo, context.current)) group = 'immo';
    else if (hasModel(data.diagnostic, context.current)) group = 'diagnostic';
    else {
      var counts = { immo: 0, diagnostic: 0 };
      related.forEach(function (item) {
        if (hasModel(data.immo, item.handle)) counts.immo++;
        if (hasModel(data.diagnostic, item.handle)) counts.diagnostic++;
      });
      group = counts.immo > counts.diagnostic ? 'immo' : 'diagnostic';
    }
    var sheet = data[group];
    if (!sheet || !sheet.models) return null;

    // The model key (not the product handle) is used to deduplicate different bundles.
    var available = Object.keys(sheet.models).map(function (id) {
      return { id: id, handle: id, url: '/products/' + encodeURIComponent(id),
        name: sheet.models[id].name, values: sheet.models[id].values, current: false };
    });
    var byId = Object.create(null);
    available.forEach(function (model) { byId[model.id] = model; });

    var defaults = [];
    var defaultPositions = Object.create(null);
    related.forEach(function (item) {
      var id = resolveHandle(sheet, item.handle);
      if (!sheet.models[id]) return;
      var model = { id: id, handle: item.handle, url: item.url || '/products/' + encodeURIComponent(item.handle),
        price: item.price, priceVaries: item.priceVaries,
        name: sheet.models[id].name, values: sheet.models[id].values, current: item.handle === context.current };
      if (defaultPositions[id] !== undefined) {
        if (model.current) defaults[defaultPositions[id]] = model;
      } else {
        defaultPositions[id] = defaults.length;
        defaults.push(model);
      }
    });

    if (group === 'cv') {
      available.forEach(function (model) {
        if (defaultPositions[model.id] === undefined) defaults.push(model);
      });
    }
    if (defaults.length < 2) return null;
    // Keep the viewed model in the initial four even when the related list is longer.
    if (defaults.length > MAX_MODELS) {
      var currentIndex = defaults.findIndex(function (model) { return model.current; });
      var first = defaults.slice(0, MAX_MODELS);
      if (currentIndex >= MAX_MODELS) first[MAX_MODELS - 1] = defaults[currentIndex];
      defaults = first;
    }
    return { sheet: sheet, group: group, available: available, byId: byId, defaults: defaults,
      currency: context.currency || 'AUD', title: context.title || '', pageUrl: context.url || location.pathname };
  }
  function makeView(sheet, models) {
    var sections = sheet.sections.map(function (section) {
      var rows = section.rows.map(function (row) {
        var values = models.map(function (model) { return clean(model.values[row.id]); });
        if (values.every(unsupported)) return null;
        var different = values.some(function (value) { return normalized(value) !== normalized(values[0]); });
        return { id: row.id, label: row.label, values: values, different: different };
      }).filter(Boolean);
      return { title: section.title, rows: rows };
    }).filter(function (section) { return section.rows.length; });
    return { models: models, sections: sections };
  }
  function addValue(parent, value) {
    var style = valueStyle(value);
    parent.appendChild(make('span', 'op-au-compare-value' + (style ? ' op-au-compare-value-' + style : ''), presentation(value)));
  }
  function desktop(view) {
    var wrap = make('div', 'op-au-compare-table-wrap');
    var table = make('table', 'op-au-compare-table');
    var thead = make('thead');
    var headings = make('tr');
    headings.appendChild(make('th', '', 'Feature'));
    view.models.forEach(function (model) {
      var th = make('th', model.current ? 'op-au-compare-current' : '');
      var link = make('a', 'op-au-compare-model-link', model.name);
      link.href = model.url;
      link.dataset.opAuCompareModelLink = model.id;
      th.appendChild(link);
      th.appendChild(priceElement(model));
      headings.appendChild(th);
    });
    thead.appendChild(headings);
    table.appendChild(thead);
    var tbody = make('tbody');
    view.sections.forEach(function (section) {
      var groupRow = make('tr', 'op-au-compare-section-row');
      var groupTitle = make('th', 'op-au-compare-section', section.title);
      groupTitle.colSpan = view.models.length + 1;
      groupRow.appendChild(groupTitle);
      tbody.appendChild(groupRow);
      section.rows.forEach(function (item) {
        var row = make('tr', 'op-au-compare-data-row');
        row.dataset.opDifferent = item.different ? '1' : '0';
        var titleCell = make('td');
        titleCell.appendChild(featureLabel(item));
        row.appendChild(titleCell);
        item.values.forEach(function (value) {
          var cell = make('td');
          addValue(cell, value);
          row.appendChild(cell);
        });
        tbody.appendChild(row);
      });
    });
    table.appendChild(tbody);
    wrap.appendChild(table);
    return wrap;
  }
  function mobile(view) {
    var wrap = make('div', 'op-au-compare-mobile');
    view.sections.forEach(function (section) {
      var group = make('section', 'op-au-compare-mobile-group');
      group.appendChild(make('h3', 'op-au-compare-mobile-group-title', section.title));
      section.rows.forEach(function (item) {
        var feature = make('div', 'op-au-compare-feature');
        feature.dataset.opDifferent = item.different ? '1' : '0';
        var mobileLabel = make('div','op-au-compare-feature-name');
        mobileLabel.appendChild(featureLabel(item));
        feature.appendChild(mobileLabel);
        view.models.forEach(function (model, index) {
          var line = make('div', 'op-au-compare-feature-model');
          line.appendChild(make('div', 'op-au-compare-feature-model-name' + (model.current ? ' is-current' : ''), model.name));
          var style = valueStyle(item.values[index]);
          line.appendChild(make('div', 'op-au-compare-feature-value' + (style ? ' is-' + style : ''), presentation(item.values[index])));
          feature.appendChild(line);
        });
        group.appendChild(feature);
      });
      wrap.appendChild(group);
    });
    return wrap;
  }
  function filterOverlay(overlay) {
    var input = overlay.querySelector('[data-op-au-compare-differences]');
    var only = !!(input && input.checked && !input.disabled);
    overlay.querySelectorAll('[data-op-different]').forEach(function (node) {
      node.hidden = only && node.dataset.opDifferent !== '1';
    });
    overlay.querySelectorAll('.op-au-compare-section-row').forEach(function (node) {
      var next = node.nextElementSibling;
      var visible = false;
      while (next && !next.classList.contains('op-au-compare-section-row')) {
        if (!next.hidden) { visible = true; break; }
        next = next.nextElementSibling;
      }
      node.hidden = !visible;
    });
    overlay.querySelectorAll('.op-au-compare-mobile-group').forEach(function (node) {
      node.hidden = !Array.from(node.querySelectorAll('.op-au-compare-feature')).some(function (feature) { return !feature.hidden; });
    });
    var empty = overlay.querySelector('[data-op-au-compare-empty]');
    if (empty) {
      empty.hidden = Array.from(overlay.querySelectorAll('.op-au-compare-data-row')).some(function (row) { return !row.hidden; });
      empty.textContent = only ? 'No differences between the selected models.' : 'No comparable features available.';
    }
  }
  function renderControls() {
    if (!state || !active) return;
    var overlay = active;
    var selectedArea = overlay.querySelector('[data-op-au-compare-selected]');
    var selector = overlay.querySelector('[data-op-au-compare-add]');
    var reset = overlay.querySelector('[data-op-au-compare-reset]');
    selectedArea.replaceChildren();
    state.selected.forEach(function (model) {
      var chip = make('div', 'op-au-compare-chip' + (model.current ? ' is-current' : ''));
      var chipDetail = make('div','op-au-compare-chip-detail');
      chipDetail.appendChild(make('span', 'op-au-compare-chip-name', model.name));
      chipDetail.appendChild(priceElement(model));
      chip.appendChild(chipDetail);
      var remove = make('button', 'op-au-compare-chip-remove', '×');
      remove.type = 'button';
      remove.dataset.opAuCompareRemove = model.id;
      remove.setAttribute('aria-label', 'Remove ' + model.name + ' from comparison');
      remove.disabled = state.selected.length <= 1;
      chip.appendChild(remove);
      selectedArea.appendChild(chip);
    });
    var limitReached = state.selected.length >= MAX_MODELS;
    selector.replaceChildren();
    var placeholder = make('option', '', limitReached ? '4 models selected' : '+ Add model');
    placeholder.value = '';
    selector.appendChild(placeholder);
    state.catalog.available.forEach(function (model) {
      if (state.selected.some(function (item) { return item.id === model.id; })) return;
      var option = make('option', '', model.name);
      option.value = model.id;
      selector.appendChild(option);
    });
    selector.value = '';
    selector.disabled = limitReached || selector.options.length <= 1;
    var unchanged = state.selected.length === state.catalog.defaults.length &&
      state.selected.every(function (model, index) { return model.id === state.catalog.defaults[index].id; });
    reset.disabled = unchanged;
    var differences = overlay.querySelector('[data-op-au-compare-differences]');
    differences.disabled = state.selected.length < 2;
    if (differences.disabled) differences.checked = false;
  }
  function renderTable() {
    if (!state || !active) return;
    var area = active.querySelector('[data-op-au-compare-content]');
    var view = makeView(state.catalog.sheet, state.selected);
    var empty = make('p', 'op-au-compare-empty', '');
    empty.dataset.opAuCompareEmpty = '';
    area.replaceChildren(desktop(view), mobile(view), empty);
    filterOverlay(active);
    state.selected.forEach(loadPrice);
    showPrices();
  }
  function update() { renderControls(); renderTable(); }

  function contactOverlay() {
    return document.querySelector('[data-op-au-compare-contact-overlay]');
  }
  var contactIsOpen = false;
  var MAX_VINS = 10;
  function vinRows(form) {
    return Array.from(form.querySelectorAll('[data-op-au-compare-vin-row]'));
  }
  function renumberVINs(form) {
    var rows = vinRows(form);
    rows.forEach(function (row, index) {
      var number = index + 1;
      var input = row.querySelector('[data-op-au-compare-vin-input]');
      var label = row.querySelector('label');
      var remove = row.querySelector('[data-op-au-compare-remove-vin]');
      if (input) {
        input.id = 'op-au-compare-contact-vin-' + number;
        input.name = 'contact[Vehicle VIN ' + number + ']';
      }
      if (label) {
        label.htmlFor = 'op-au-compare-contact-vin-' + number;
        label.textContent = 'Vehicle VIN ' + number;
      }
      if (remove) {
        remove.hidden = rows.length === 1;
        remove.setAttribute('aria-label', 'Remove vehicle VIN ' + number);
      }
    });
    var add = form.querySelector('[data-op-au-compare-add-vin]');
    if (add) add.hidden = rows.length >= MAX_VINS;
  }
  function addVIN(form) {
    var list = form.querySelector('[data-op-au-compare-vin-list]');
    if (!list || vinRows(form).length >= MAX_VINS) return;
    var template = vinRows(form)[0];
    if (!template) return;
    var next = template.cloneNode(true);
    var input = next.querySelector('[data-op-au-compare-vin-input]');
    if (input) input.value = '';
    list.appendChild(next);
    renumberVINs(form);
    if (input) input.focus();
  }
  function restoreSubmitButton(form) {
    if (!form) return;
    var button = form.querySelector('[data-op-au-compare-contact-submit]');
    if (button) {
      button.textContent = 'Send request';
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
  function clearContactForNextRequest(contact) {
    if (!contact) return;
    var form = contact.querySelector('#obdprice-au-compare-contact');
    if (!form) return;
    var email = form.querySelector('[name="contact[email]"]');
    var functions = form.querySelector('[name="contact[Required Functions]"]');
    if (email) email.value = '';
    if (functions) functions.value = '';
    vinRows(form).forEach(function (row, index) {
      if (index) row.remove();
      else {
        var vin = row.querySelector('[data-op-au-compare-vin-input]');
        if (vin) vin.value = '';
      }
    });
    renumberVINs(form);
    var fields = form.querySelector('.op-au-compare-contact-fields');
    if (fields) fields.hidden = false;
    contact.querySelectorAll('[data-op-au-compare-contact-result]').forEach(function (notice) {
      notice.hidden = true;
    });
    restoreSubmitButton(form);
  }
  function openContact() {
    var contact = contactOverlay();
    if (!contact || !active || !state) return;
    var title = state.catalog.title || document.title || 'Autel Scanner';
    var reference = '[OBDPRICE AU] ' + title;
    var titleInput = contact.querySelector('[data-op-au-compare-contact-title]');
    if (titleInput) titleInput.value = reference;
    active.classList.add('op-au-compare-is-behind-contact');
    active.setAttribute('aria-hidden','true');
    contact.hidden = false;
    contactIsOpen = true;
    var first = contact.querySelector('input[type="email"]') || contact.querySelector('[data-op-au-compare-contact-close]');
    if (first) first.focus();
  }
  function closeContact() {
    var contact = contactOverlay();
    if (!contact || !contactIsOpen) return;
    contact.hidden = true;
    contactIsOpen = false;
    clearContactForNextRequest(contact);
    if (!active) document.body.style.overflow = previousOverflow;
    if (active) {
      active.classList.remove('op-au-compare-is-behind-contact');
      active.removeAttribute('aria-hidden');
      var button = active.querySelector('[data-op-au-compare-inquiry-toggle]');
      if (button) button.focus();
    }
  }
  function open(button) {
    var root = getRoot(button);
    var overlay = root && root.querySelector('[data-op-au-compare-overlay]');
    var context = getContext(root);
    var catalog = getCatalog(context);
    if (!catalog || !overlay) return;
    if (active) close();
    lastFocus = button;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    overlay.hidden = false;
    active = overlay;
    state = { catalog: catalog, selected: catalog.defaults.slice(), context: context,
      prices: Object.create(null), loading: Object.create(null) };
    catalog.defaults.forEach(function (model) {
      savePrice(model,model.price,model.priceVaries);
    });
    overlay.querySelector('[data-op-au-compare-differences]').checked = false;
    update();
    overlay.querySelector('[data-op-au-compare-close]').focus();
  }
  function close() {
    if (!active) return;
    if (contactIsOpen) closeContact();
    active.hidden = true;
    active = null;
    state = null;
    document.body.style.overflow = previousOverflow;
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
    lastFocus = null;
  }
  function init(root) {
    (root || document).querySelectorAll('.cs_related_products_section').forEach(function (section) {
      var opener = section.querySelector('[data-op-au-compare-open]');
      if (!opener) return;
      opener.hidden = !getCatalog(getContext(section));
    });
  }
  document.addEventListener('click', function (event) {
    var contact = contactOverlay();
    if (contactIsOpen && contact && (event.target.closest('[data-op-au-compare-contact-close]') || event.target === contact)) {
      closeContact(); return;
    }
    var opener = event.target.closest('[data-op-au-compare-open]');
    if (opener) { open(opener); return; }
    if (!active) return;
    if (event.target.closest('[data-op-au-compare-close]') || event.target === active) { close(); return; }
    var helpButton = event.target.closest('[data-op-au-compare-help]');
    if (helpButton && active.contains(helpButton)) {
      var expanded = helpButton.getAttribute('aria-expanded') === 'true';
      helpButton.setAttribute('aria-expanded', String(!expanded));
      var tooltip = helpButton.nextElementSibling;
      if (tooltip) tooltip.hidden = expanded;
      return;
    }
    var inquiryOpen = event.target.closest('[data-op-au-compare-inquiry-toggle]');
    if (inquiryOpen && active.contains(inquiryOpen)) { openContact(); return; }
    var remove = event.target.closest('[data-op-au-compare-remove]');
    if (remove && active.contains(remove) && state.selected.length > 1) {
      var id = remove.dataset.opAuCompareRemove;
      state.selected = state.selected.filter(function (model) { return model.id !== id; });
      update();
      active.querySelector('[data-op-au-compare-add]').focus();
      return;
    }
    var reset = event.target.closest('[data-op-au-compare-reset]');
    if (reset && active.contains(reset)) {
      state.selected = state.catalog.defaults.slice();
      update();
      active.querySelector('[data-op-au-compare-reset]').focus();
    }
  });
  document.addEventListener('change', function (event) {
    if (!active) return;
    if (event.target.matches('[data-op-au-compare-differences]')) { filterOverlay(active); return; }
    if (event.target.matches('[data-op-au-compare-add]')) {
      var id = event.target.value;
      if (!id || state.selected.length >= MAX_MODELS || !state.catalog.byId[id] ||
          state.selected.some(function (model) { return model.id === id; })) return;
      state.selected.push(state.catalog.byId[id]);
      update();
    }
  });
  document.addEventListener('click', function (event) {
    var add = event.target.closest('[data-op-au-compare-add-vin]');
    if (add) {
      var form = add.closest('#obdprice-au-compare-contact');
      if (form) addVIN(form);
      return;
    }
    var remove = event.target.closest('[data-op-au-compare-remove-vin]');
    if (remove) {
      var row = remove.closest('[data-op-au-compare-vin-row]');
      var form = remove.closest('#obdprice-au-compare-contact');
      if (row && form && vinRows(form).length > 1) {
        row.remove();
        renumberVINs(form);
      }
    }
  });
  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-op-au-compare-vin-input]')) return;
    var input = event.target;
    var selectionStart = input.selectionStart;
    var updated = input.value.toUpperCase();
    if (updated !== input.value) {
      input.value = updated;
      if (selectionStart !== null) input.setSelectionRange(selectionStart, selectionStart);
    }
  });
  document.addEventListener('submit', function (event) {
    if (!event.target.matches('#obdprice-au-compare-contact')) return;
    var form = event.target;
    form.querySelectorAll('[data-op-au-compare-vin-input]').forEach(function (vin) {
      vin.value = clean(vin.value).toUpperCase();
    });
    var button = form.querySelector('[data-op-au-compare-contact-submit]');
    if (button) {
      button.textContent = 'Submitting...';
      button.setAttribute('aria-busy', 'true');
      // Keep the button operable for Shopify's asynchronous CAPTCHA challenge.
    }
    // Do not prevent the native POST: Shopify manages contact submission and CAPTCHA.
  });
  window.addEventListener('pageshow', function () {
    var contact = contactOverlay();
    if (contact) restoreSubmitButton(contact.querySelector('#obdprice-au-compare-contact'));
  });
  document.addEventListener('keydown', function (event) {
    if (!active && !contactIsOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      if (contactIsOpen) closeContact(); else close();
      return;
    }
    if (event.key !== 'Tab') return;
    var surface = contactIsOpen ? contactOverlay() : active;
    if (!surface) return;
    var focusable = Array.from(surface.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]):not([aria-hidden="true"])'))
      .filter(function (element) { return element.getClientRects().length > 0; });
    if (!focusable.length) { event.preventDefault(); surface.querySelector('[role="dialog"]').focus(); return; }
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  function initialize() {
    init();
    var contact = contactOverlay();
    if (contact && contact.querySelector('[data-op-au-compare-contact-result]')) {
      contact.hidden = false;
      contactIsOpen = true;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      var focus = contact.querySelector('[data-op-au-compare-contact-close]');
      if (focus) focus.focus();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
